// @ts-nocheck
import React from "react";
import PropTypes from 'prop-types';

import ModalV4 from "../../../../app/ui/modal/v4/v4";
import ModalGoToMain from "./quick-search/go-to-main";
import QuickSearch_ModalNavigation from "./navigation/navigation";

import _ from 'lodash';

class ModalMagicSearch extends ModalV4 {

    static propTypes = {
        params: PropTypes.shape({
            defaultTab: PropTypes.oneOf(['goto', 'search', 'recent']),
            searchData: PropTypes.object,
            onSubmit: PropTypes.func
        })
    }

    state = {
        selectedId: _.get(this, 'props.params.defaultTab', 'goto')
    }

    onChangeNavigation = (id) => {
        this.setState({
            selectedId: id
        })
    }

    render() {
        let Main;
        const navigation = <QuickSearch_ModalNavigation selectedId={this.state.selectedId} onChange={this.onChangeNavigation}/>;

        switch (this.state.selectedId) {
            case 'goto':    Main = ModalGoToMain; break;
            // case 'search':  Main = ModalSearchMain; break;
            // case 'recent':  Main = ModalRecentMain; break;
        }

        return <Main className="v4-container placement-middle"
                     navigation={navigation} {...this.props.params} onClick={this.stopPropagation}
                     onCloseModal={this.closeModal}/>;
    }
}

module.exports = ModalMagicSearch;